import React from 'react';
import { useRouteError } from 'react-router-dom';
import { PageError } from '../PageError';
import { getErrorMessage, isPrintToPdfMode, signalPdfError } from '../utils';
export const GlobalError = (props) => {
    const error = useRouteError();
    React.useEffect(() => {
        if (isPrintToPdfMode()) {
            signalPdfError(getErrorMessage(error));
        }
    }, [error]);
    switch (props.type) {
        case 'not-found':
            return React.createElement(PageError, Object.assign({}, props));
        case 'access-issue':
            return React.createElement(PageError, Object.assign({}, props));
        default:
            console.error(error);
            return React.createElement(PageError, Object.assign({ error: error }, props));
    }
};
